import type { FC } from 'react';
import { useCallback } from 'react';
import { useLocation } from '../../../../context/LocationContext';
import type { OrderLineOptionDto } from '../../../../../generated-api';
import { rightPrice } from '../../../../hooks/useTotalPrice';
import { useCheckout } from '../../../../context/CheckoutContext';
import { getOrderLineOptionKey } from '../../../../utils/orderLineUtils';

interface Props {
  options: OrderLineOptionDto[];
}

const CartItemOptions: FC<Props> = ({ options }) => {
  const { formatCurrency } = useLocation();
  const { vatType } = useCheckout();

  const getOptionLabel = useCallback(
    (option: OrderLineOptionDto, vat: 'EAT_IN' | 'TAKEAWAY') => {
      const typeSymbol = option.type === 'REMOVABLE' ? '- ' : '+ ';
      const price = rightPrice(vat, option.price, option.takeawayPrice);
      return typeSymbol
        .concat(option.quantity > 1 ? `${option.quantity} ` : '')
        .concat(option.name)
        .concat(price === 0 ? '' : ` (${formatCurrency(price * option.quantity)})`);
    },
    [formatCurrency]
  );

  return (
    <ul>
      {options.map((option) => (
        <li key={`${getOrderLineOptionKey(option)}`} className="text-small text-grey-dark">
          {getOptionLabel(option, vatType)}
        </li>
      ))}
    </ul>
  );
};

export default CartItemOptions;
